export default __webpack_public_path__ + "static/media/scroll-top.54423454.svg";